import React, { useState, useEffect } from "react";
import s from "./MatrizControlED.module.css";

//services
import reportService from "../../../api/reports/reportsServices";

//assets
import { handleExcelInstant, handleExcelPreprinted } from "./Helper/export";
import { currencyFormat } from "../../../helpers/currency";
import { createHeader } from "./Helper/tableHelpers";
import printTable from "../../../helpers/imprimir";
import totalByColumn from "./Helper/totalByColumn";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

//Custom Components
import { Currency, Quantity } from "../../../helpers/currencyConvert";
import Pager from "../../Shared/Pagination/Pagination";
import FiltrosMatrizControlED from "./Filters";

//Material Ui
import {
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  CircularProgress,
  Snackbar,
  Alert,
  Button,
  TableRow,
} from "@mui/material";
import LocalPrintshopRoundedIcon from "@mui/icons-material/LocalPrintshopRounded";
import DescriptionIcon from "@mui/icons-material/Description";
import ReceiptIcon from "@mui/icons-material/Receipt";

export const MatrizControlED = () => {
  const { textColor } = useSelector((state) => state.local);
  const { formatCurrency } = currencyFormat();
  const { t } = useTranslation();

  const [games, setGames] = useState([]);
  const [loadingFilters, setLoadingFilters] = useState(false);
  const [filters, setFilters] = useState({
    type: 0,
    gameId: 0,
    agencyFrom: "",
    agencyTo: "",
    drawDate: null,
    createDate: null,
    series: [],
  });
  const [reportLoading, setReportLoading] = useState(false);
  const [completeReport, setCompleteReport] = useState([]);
  const [printing, setPrinting] = useState(false);
  //Paginado
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [openError, setOpenError] = useState(false);
  const [noResult, setNoResult] = useState(false);
  const [sort, setSort] = useState({
    criteria: "ASC",
    field: "agencyNumber",
  });

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const [pageCustom, setPageCustom] = useState(1);

  const [headersSeries, setHeadersSeries] = useState([]);
  const [headerInstantaneo, setHeaderInstantaneo] = useState([t("agency")]);
  const [sortInstantaneo, setSortInstantaneo] = useState(["agencyNumber"]);

  const { currentLogo } = useSelector((state) => state.local);
  const [logo, setLogo] = useState("");

  const headerPreimpreso = [
    t("agency"),
    t("delivery"),
    t("return"),
    t("sales"),
    t("collection"),
    t("expired"),
  ];

  const sortPreimpreso = [
    "agencyNumber",
    "deliveryCount",
    "returnCount",
    "salesCount",
    "salesAmount",
    "expiredAmount",
  ];

  const handleSort = (item) => {
    setSort((prev) => ({
      criteria:
        prev.field === item
          ? prev.criteria === "DESC"
            ? "ASC"
            : "DESC"
          : "DESC",
      field: item,
    }));
  };

  const getData = (pagina) => {
    if (
      filters.type &&
      filters.gameId &&
      (filters.drawDate || filters.createDate)
    ) {
      setLoading(true);
      if (filters.type === 1) {
        reportService
          .getPreprintedMatrizData(pagina, pageSize, sort, filters)
          .then((res) => {
            if (res.content.length === 0) {
              setNoResult(true);
            }
            setItems(res.content);
            setTotalPages(res.totalPages);
            setTotalResults(res.totalElements);
          })
          .then(() => setLoading(false))
          .catch((e) => {
            console.log(e);
            setOpenError(true);
            setLoading(false);
          });
      } else {
        reportService
          .getInstantMatrizData(pagina, pageSize, sort, filters)
          .then((res) => {
            setItems(res.content);
            setTotalPages(res.totalPages);
            setTotalResults(res.totalElements);
            setHeadersSeries(filters?.series);
          })
          .then(() => setLoading(false))
          .catch((e) => {
            setOpenError(true);
            setLoading(false);
          });
      }
    }
  };

  const getAllData = () => {
    if (
      filters.type &&
      filters.gameId &&
      (filters.drawDate || filters.createDate)
    ) {
      setReportLoading(true);
      if (filters.type === 1) {
        reportService
          .getAllPreprintedMatrizData(sort, filters)
          .then((res) => {
            if (res.length === 0) {
              setNoResult(true);
            }
            setCompleteReport(res);
          })
          .then(() => setReportLoading(false))
          .catch((e) => {
            console.log(e);
            setOpenError(true);
          });
      } else {
        reportService
          .getAllnstantMatrizData(sort, filters)
          .then((res) => setCompleteReport(res))
          .then(() => setReportLoading(false))
          .catch((e) => {
            setOpenError(true);
          });
      }
    }
  };

  const handleConsult = () => {
    getData(1);
    setPage(1);
    setTotalPages(1);
  };

  useEffect(() => {
    getData(page);
  }, [page, pageSize, sort]);

  useEffect(() => {
    getAllData();
  }, [sort]);

  useEffect(() => {
    setHeaderInstantaneo([t("agency"), ...headersSeries]);
    setSortInstantaneo(["agencyNumber", ...headersSeries]);
  }, [headersSeries]);

  useEffect(() => {
    setLogo(currentLogo?.imgBase64);
  }, [currentLogo]);

  useEffect(() => {
    if (printing === true) {
      printTable(document.getElementById("matriz-table"));
      setPrinting(false);
    }
  }, [printing]);

  return (
    <Grid container item xs={12} className={s.container}>
      <Grid item xs={12} className={s.header}>
        <Grid item container xs={12} className={s.titleContainer}>
          <Grid
            item
            xs={11}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <ReceiptIcon
              sx={{ fontSize: "2rem", color: "primary.main", mr: 2 }}
            />
            <h4>{t("controlMatrixDeliveryReturn")}</h4>
          </Grid>
        </Grid>
      </Grid>

      {loadingFilters ? (
        <Grid
          item
          xs={11}
          sx={{ display: "flex", alignItems: "center", height: "50px" }}
        >
          <CircularProgress color="primary" />
          <p style={{ margin: 0, marginLeft: "10px" }}>{t("loadingFilter")}</p>
        </Grid>
      ) : (
        <>
          <FiltrosMatrizControlED
            setTotalResults={setTotalResults}
            handleConsult={handleConsult}
            setItems={setItems}
            getAllData={getAllData}
            filters={filters}
            setFilters={setFilters}
            setLoadingFilters={setLoadingFilters}
            games={games}
            setGames={setGames}
          />
          <Grid item xs={11} className={s.options}>
            <Grid item xs={6}>
              {loading ? (
                <CircularProgress size="1.2rem" />
              ) : (
                <p
                  style={{ fontSize: "1.2rem", margin: 0 }}
                >{`${t("results")}: ${totalResults}`}</p>
              )}
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                size="small"
                onClick={() => setPrinting(true)}
                variant="contained"
                sx={{ ml: 1 }}
                disabled={!items?.length}
              >
                <LocalPrintshopRoundedIcon
                  color={textColor}
                  sx={{ fontSize: "30px" }}
                />
                <p>{t("print")}</p>
              </Button>
              <Button
                size="small"
                variant="contained"
                disabled={!items?.length}
                sx={{ ml: 1 }}
                onClick={() => {
                  if (filters.type === 1) {
                    handleExcelPreprinted(completeReport, formatCurrency);
                  } else if (filters.type === 2) {
                    handleExcelInstant(
                      completeReport,
                      formatCurrency,
                      filters.series,
                    );
                  }
                }}
              >
                <DescriptionIcon color={textColor} sx={{ fontSize: "30px" }} />
                <p>Excel</p>
              </Button>
            </Grid>
          </Grid>
        </>
      )}

      {!filters.type ? (
        <Grid item xs={12} className={s.loader} key={3}>
          <p>{t("selectGameType")}</p>
        </Grid>
      ) : !filters.gameId ? (
        <Grid item xs={12} className={s.loader} key={3}>
          <p>{t("pleaseSelectGame")}</p>
        </Grid>
      ) : loading ? (
        <Grid item xs={12} className={s.loader} key={1}>
          <CircularProgress size={"4rem"} />
        </Grid>
      ) : items?.length ? (
        <Grid item container xs={11} className={s.data} id="matriz-table">
          {printing !== true ? null : (
            <div className="logo">
              <img src={logo} alt="logo" />
            </div>
          )}
          {filters.type === 1 ? (
            <>
              <TableContainer className={s.tableContainer} key={1}>
                <Table className="print-table" stickyHeader>
                  <TableHead>
                    {createHeader(
                      headerPreimpreso,
                      textColor,
                      sortPreimpreso,
                      sort,
                      handleSort,
                    )}
                  </TableHead>
                  <TableBody>
                    {items?.map((item, i) => (
                      <React.Fragment key={i}>
                        <TableRow>
                          <TableCell>{`(${item?.agencyNumber}) ${item?.agencyName}`}</TableCell>
                          <TableCell align="center">
                            <Quantity value={item?.deliveryCount} />
                          </TableCell>
                          <TableCell align="center">
                            <Quantity value={item?.returnCount} />
                          </TableCell>
                          <TableCell align="center">
                            <Quantity value={item?.salesCount} />
                          </TableCell>
                          <TableCell align="right">
                            <Currency value={item?.salesAmount} />
                          </TableCell>
                          <TableCell align="right">
                            <Currency value={item?.expiredAmount} />
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>
                        {t("totals")}:
                      </TableCell>
                      <TableCell align="center">
                        <Quantity
                          value={items.reduce(
                            (acc, item) => acc + item?.deliveryCount,
                            0,
                          )}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Quantity
                          value={items.reduce(
                            (acc, item) => acc + item?.returnCount,
                            0,
                          )}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Quantity
                          value={items.reduce(
                            (acc, item) => acc + item?.salesCount,
                            0,
                          )}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <Currency
                          value={items.reduce(
                            (acc, item) => acc + item?.salesAmount,
                            0,
                          )}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <Currency
                          value={items.reduce(
                            (acc, item) => acc + item?.expiredAmount,
                            0,
                          )}
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (
            <TableContainer className={s.tableContainer} key={2}>
              <Table className="print-table" stickyHeader>
                <TableHead>
                  {createHeader(
                    headerInstantaneo,
                    textColor,
                    sortInstantaneo,
                    sort,
                    handleSort,
                  )}
                </TableHead>
                <TableBody>
                  {printing != true
                    ? items.map((item, i) => (
                        <React.Fragment key={i}>
                          <TableRow>
                            <TableCell>{`(${item.agencyNumber}) ${item.agencyName}`}</TableCell>
                            {headersSeries.map((s, i) => (
                              <TableCell align="center" key={i}>
                                <Currency
                                  value={
                                    item?.series?.find((obj) => s === obj?.name)
                                      ?.amount || 0
                                  }
                                />
                              </TableCell>
                            ))}
                          </TableRow>
                        </React.Fragment>
                      ))
                    : completeReport.map((item, i) => (
                        <React.Fragment key={i}>
                          <TableRow>
                            <TableCell>{`(${item.agencyNumber}) ${item.agencyName}`}</TableCell>
                            {headersSeries.map((s, i) => (
                              <TableCell align="center" key={i}>
                                <Currency
                                  value={
                                    item?.series?.find((obj) => s === obj?.name)
                                      ?.amount || 0
                                  }
                                />
                              </TableCell>
                            ))}
                          </TableRow>
                        </React.Fragment>
                      ))}
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600 }}>
                      {t("totals")}:
                    </TableCell>
                    {reportLoading != true ? (
                      totalByColumn(completeReport, headersSeries).map(
                        (item) => (
                          <React.Fragment>
                            <TableCell align="center">
                              <Currency value={item} />
                            </TableCell>
                          </React.Fragment>
                        ),
                      )
                    ) : (
                      <Grid
                        item
                        xs={11}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          height: "5px",
                        }}
                      >
                        <CircularProgress color="primary" />
                        <p style={{ margin: 0, marginLeft: "10px" }}>
                          {t("loadingFilter")}
                        </p>
                      </Grid>
                    )}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Grid>
      ) : (
        <Grid item xs={12} className={s.loader} key={2}>
          <p>{t("noResults")}</p>
        </Grid>
      )}
      <Grid
        item
        container
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          aligntItems: "center",
          mb: 10,
        }}
      >
        <Pager
          pageSize={pageSize}
          setPageSize={setPageSize}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageCustom={pageCustom}
          setPageCustom={setPageCustom}
        />
      </Grid>
      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          variant="filled"
          onClose={() => setOpenError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {t("tryInOtherMoment")}
        </Alert>
      </Snackbar>
      <Snackbar
        open={noResult}
        autoHideDuration={6000}
        onClose={() => setNoResult(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          variant="filled"
          onClose={() => setNoResult(false)}
          severity="info"
          sx={{ width: "100%" }}
        >
          {t("noResults")}
        </Alert>
      </Snackbar>
    </Grid>
  );
};
